import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import EntityLocationsList from "./EntityLocationsList";
import EntityLocationCreate from "./EntityLocationCreate";

export const entitieslocation = {
  list: EntityLocationsList,
  create: EntityLocationCreate,
  icon: LocationOnOutlinedIcon,
  options: { label: "Location de l'entité" },
};
